import API from 'utils/api';
import getFormattedValues, { hasFiles, formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'usuarios/funcionario/';
const files = ['foto', 'firma_electronica'];

/**
 * GET Funcionarios
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getFuncionarios = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Funcionario
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getFuncionario = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Funcionario
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postFuncionario = async (values) => {
  try {
    const config = hasFiles(values, files) ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: false,
    });
    const response = await API.post(baseURI, formattedValues, config);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Funcionario
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchFuncionario = async (id, values) => {
  try {
    const config = hasFiles(values, files) ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: false,
    });
    const response = await API.patch(`${baseURI}${id}`, formattedValues, config);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Funcionario
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteFuncionario = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
